// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/get_shotlist.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionShot } from "./vision_shot_pb";
import { file_vision_shotlist_v1_vision_shot } from "./vision_shot_pb";
import type { VisionCastMember } from "./vision_cast_member_pb";
import { file_vision_shotlist_v1_vision_cast_member } from "./vision_cast_member_pb";
import type { VisionProp } from "./vision_prop_pb";
import { file_vision_shotlist_v1_vision_prop } from "./vision_prop_pb";
import type { VisionShotlistConfig } from "./vision_shotlist_config_pb";
import { file_vision_shotlist_v1_vision_shotlist_config } from "./vision_shotlist_config_pb";
import type { VisionShotlistPresetBanks } from "./vision_shotlist_preset_pb";
import { file_vision_shotlist_v1_vision_shotlist_preset } from "./vision_shotlist_preset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/get_shotlist.proto.
 */
export const file_vision_shotlist_v1_get_shotlist: GenFile = /*@__PURE__*/
  fileDesc("CiV2aXNpb24vc2hvdGxpc3QvdjEvZ2V0X3Nob3RsaXN0LnByb3RvEhlwcm90b3MudmlzaW9uLnNob3RsaXN0LnYxIngKEkdldFNob3RsaXN0UmVxdWVzdBJECgZwYXJhbXMYASABKAsyNC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkdldFNob3RsaXN0UmVxdWVzdC5QYXJhbXMaHAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkilgMKE0dldFNob3RsaXN0UmVzcG9uc2USRQoGcmVzdWx0GAEgASgLMjUucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5HZXRTaG90bGlzdFJlc3BvbnNlLlJlc3VsdBq3AgoGUmVzdWx0EjQKBXNob3RzGAEgAygLMiUucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90EjkKBGNhc3QYAiADKAsyKy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvbkNhc3RNZW1iZXISNAoFcHJvcHMYAyADKAsyJS5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblByb3ASPwoGY29uZmlnGAQgASgLMi8ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdENvbmZpZxJFCgdwcmVzZXRzGAUgASgLMjQucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdFByZXNldEJhbmtzYgZwcm90bzM", [file_vision_shotlist_v1_vision_shot, file_vision_shotlist_v1_vision_cast_member, file_vision_shotlist_v1_vision_prop, file_vision_shotlist_v1_vision_shotlist_config, file_vision_shotlist_v1_vision_shotlist_preset]);

/**
 * @generated from message protos.vision.shotlist.v1.GetShotlistRequest
 */
export type GetShotlistRequest = Message<"protos.vision.shotlist.v1.GetShotlistRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.GetShotlistRequest.Params params = 1;
   */
  params?: GetShotlistRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.GetShotlistRequest.
 * Use `create(GetShotlistRequestSchema)` to create a new message.
 */
export const GetShotlistRequestSchema: GenMessage<GetShotlistRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_get_shotlist, 0);

/**
 * @generated from message protos.vision.shotlist.v1.GetShotlistRequest.Params
 */
export type GetShotlistRequest_Params = Message<"protos.vision.shotlist.v1.GetShotlistRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.GetShotlistRequest.Params.
 * Use `create(GetShotlistRequest_ParamsSchema)` to create a new message.
 */
export const GetShotlistRequest_ParamsSchema: GenMessage<GetShotlistRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_get_shotlist, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.GetShotlistResponse
 */
export type GetShotlistResponse = Message<"protos.vision.shotlist.v1.GetShotlistResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.GetShotlistResponse.Result result = 1;
   */
  result?: GetShotlistResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.GetShotlistResponse.
 * Use `create(GetShotlistResponseSchema)` to create a new message.
 */
export const GetShotlistResponseSchema: GenMessage<GetShotlistResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_get_shotlist, 1);

/**
 * @generated from message protos.vision.shotlist.v1.GetShotlistResponse.Result
 */
export type GetShotlistResponse_Result = Message<"protos.vision.shotlist.v1.GetShotlistResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionShot shots = 1;
   */
  shots: VisionShot[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionCastMember cast = 2;
   */
  cast: VisionCastMember[];

  /**
   * @generated from field: repeated protos.vision.shotlist.v1.VisionProp props = 3;
   */
  props: VisionProp[];

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistConfig config = 4;
   */
  config?: VisionShotlistConfig | undefined;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPresetBanks presets = 5;
   */
  presets?: VisionShotlistPresetBanks | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.GetShotlistResponse.Result.
 * Use `create(GetShotlistResponse_ResultSchema)` to create a new message.
 */
export const GetShotlistResponse_ResultSchema: GenMessage<GetShotlistResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_get_shotlist, 1, 0);

